import React from 'react';
import { useRoughCanvas } from '@/hooks/useRoughCanvas';

interface RoughButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  seed?: number;
}

const RoughButton: React.FC<RoughButtonProps> = ({
  children,
  variant = 'primary',
  href,
  onClick,
  className = '',
  seed = 1,
}) => {
  const isPrimary = variant === 'primary';

  const canvasRef = useRoughCanvas(
    (rc, w, h) => {
      rc.rectangle(2, 2, w - 4, h - 4, {
        stroke: isPrimary ? '#3475db' : '#8b9dc3',
        strokeWidth: isPrimary ? 2.2 : 1.8,
        roughness: 1,
        seed,
        fill: isPrimary ? '#428fe9' : undefined,
        fillStyle: isPrimary ? 'solid' : undefined,
      });
    },
    [variant, seed],
  );

  const content = (
    <div className={`rough-btn rough-btn--${variant} ${className}`}>
      <canvas
        ref={canvasRef}
        className="rough-btn__canvas"
        aria-hidden="true"
      />
      <span className="rough-btn__label">{children}</span>
    </div>
  );

  if (href) {
    return (
      <a href={href} onClick={onClick} className="rough-btn__link">
        {content}
      </a>
    );
  }

  return (
    <button onClick={onClick} className="rough-btn__link">
      {content}
    </button>
  );
};

export default RoughButton;
